import { render, staticRenderFns } from "./SidebarError.vue?vue&type=template&id=1e9b3078&scoped=true&"
import script from "./SidebarError.vue?vue&type=script&lang=ts&"
export * from "./SidebarError.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarError.vue?vue&type=style&index=0&id=1e9b3078&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9b3078",
  null
  
)

export default component.exports